<h2 mat-dialog-title>{{ data.provider ? 'Counter-sign as OptixWay' : 'Sign contract' }} {{ data.contractNo }}</h2>

<mat-dialog-content>
  <div class="sign-dialog-form br-flex br-flex-column br-mt-1">
    <div class="br-flex br-gap-3">
      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>Full legal name</mat-label>
        <input matInput [(ngModel)]="signerName" maxlength="255">
      </mat-form-field>
      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>Email (optional)</mat-label>
        <input matInput type="email" [(ngModel)]="signerEmail" maxlength="256">
      </mat-form-field>
    </div>

    <app-signature-pad (signatureChange)="onSignature($event)"></app-signature-pad>

    <mat-checkbox [(ngModel)]="agreed" class="br-mt-1">
      I have read and agree to the terms of this contract, and this is my legal signature.
    </mat-checkbox>

    <div *ngIf="error" class="br-small br-text-danger">{{ error }}</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="br-gap-2">
  <button type="button" class="br-btn br-btn--outline-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="br-btn br-btn--primary" (click)="submit()" [disabled]="!canSign">
    {{ saving ? 'Signing…' : 'Sign contract' }}
  </button>
</mat-dialog-actions>
